import React from 'react';
import { Button, HStack, IButtonProps, ITextProps, Text } from 'native-base';
import { useDoctorVoice } from '../hooks/useDoctorVoice';
import { Icon } from '../../Common/components/Icon';
import { faPhoneHangup } from '@fortawesome/pro-solid-svg-icons/faPhoneHangup';
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { brandFromCustomerID } from '../../Common/utils/brandFromCustomerID';

export function DoctorVoiceNumber({
  number,
  customerId,
  customerName,
  consult,
  textProps,
  label,
  buttonProps,
}: {
  number?: string | undefined | null;
  customerId?: string | undefined | null;
  customerName?: string | undefined | null;
  consult?: string | undefined | null;
  textProps?: ITextProps;
  label?: string;
  buttonProps?: IButtonProps;
}) {
  const { makeCall, inCall, connected } = useDoctorVoice();

  const brand = brandFromCustomerID(customerId ?? '');

  const isThisInCall = inCall === number;

  return (
    <Button
      disabled={!connected}
      opacity={connected ? 1 : 0.5}
      bg={isThisInCall ? 'red.500' : 'white'}
      variant={'outline'}
      size={'xs'}
      onPress={() => makeCall(brand as string, number, customerId, customerName, consult)}
      {...buttonProps}
    >
      <HStack alignItems={'center'} space={2}>
        <Icon
          color={isThisInCall ? 'white' : 'black'}
          icon={isThisInCall ? faPhoneHangup : faPhone}
          size={'sm'}
        />
        <Text
          color={isThisInCall ? 'white' : null}
          fontWeight={isThisInCall ? 600 : null}
          {...textProps}
        >
          {label ?? number}
        </Text>
      </HStack>
    </Button>
  );
}
